import { z } from 'zod'

export const LocationCreateSchema = z.object({
  code: z.string(),
})

export type LocationCreateModel = z.infer<typeof LocationCreateSchema>

export const LocationUpdateSchema = z.object({
  id: z.number(),
  code: z.string(),
})

export type LocationUpdateModel = z.infer<typeof LocationUpdateSchema>
